import { Box, Popover, Typography } from '@mui/material';
import { StyledTypographyBodyBold } from 'components/shared/Typography/Typography.styles';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { StyledRosterInfoPopoverBox } from './RosterInfoPopover.styles';

const RosterInfoPopover = ({
  id,
  open,
  anchorElInfo,
  handleInfoClose,
  rosterPublishDate
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan'
  });

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorElInfo}
      onClose={handleInfoClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <StyledRosterInfoPopoverBox>
        <Box>
          <StyledTypographyBodyBold>
            {t('dataGrid.lastPublishDate')}
          </StyledTypographyBodyBold>
          <Typography>
            {rosterPublishDate?.lastPublishDate
              ? dayjs(rosterPublishDate.lastPublishDate).format('DD-MM-YYYY')
              : '—'}
          </Typography>
        </Box>
        <Box>
          <StyledTypographyBodyBold>
            {t('dataGrid.visibleUntilDate')}
          </StyledTypographyBodyBold>
          <Typography>
            {rosterPublishDate?.visibleUntilDate
              ? dayjs(rosterPublishDate.visibleUntilDate).format('DD-MM-YYYY')
              : '—'}
          </Typography>
        </Box>
      </StyledRosterInfoPopoverBox>
    </Popover>
  );
};

export default RosterInfoPopover;
